/**
 * Suncoast Communities brand tokens, read from suncoast-communities.com's own
 * stylesheet on 2026-08-27 so the portal matches the site rather than
 * approximating it.
 *
 * Their body and heading typeface is "Mozaic GEO Variable", which is licensed
 * for their site. We do not redistribute it here; the stack below falls through
 * to system sans-serif. If they own a licence that covers this portal, add the
 * webfont and put it at the front of `fontFamily`.
 */
export const brand = {
  primary: '#278f9b',
  primaryHover: '#217983',
  primaryDark: '#21666d',
  primaryDarker: '#1a383c',
  secondary: '#eb6341',
  secondaryHover: '#e5532f',
  textBody: '#696e6e',
  textHeader: '#1b2323',
  link: '#0d6a73',
  border: '#e3e3e3',
  pageBackground: '#fcfcfc',
  sandBackground: '#e7dcd6',
  /** Their own success and error colours, so on-track / off-track reads as Suncoast. */
  success: '#23775a',
  successBackground: '#e4f7f2',
  error: '#cd2340',
  errorBackground: '#fff1f4',
} as const;
